import { errorImageAttachment } from 'owa-locstrings/lib/strings/errorimageattachment.locstring.json';
import loc from 'owa-localize';
import handleSetViewStateFailure from './handleSetViewStateFailure';
import { getSxSViewStore, SharePointFileViewState } from 'owa-group-files-hub-store';

import { lazySetImagePreviewState, PreviewPaneViewStateBase } from 'owa-sxsdata';

export const imagePreviewSize: number = 1024;
// Thumbnail url template contains an access token which will expire after 6 hours.
const tokenValidTimeInMilliSecond: number = 21300000; // 5 hours and 55 minitues.

export default async function setViewStateForImagePreview(
    fileViewState: SharePointFileViewState,
    optionalParameters: PreviewPaneViewStateBase
) {
    const datapoint = getSxSViewStore().datapoint; // This datapoint will end in the onLoad callbck function in FilesHubSxSLayerView
    try {
        if (fileViewState.retrievedTime) {
            const cacheAge = new Date().getTime() - fileViewState.retrievedTime.getTime();
            if (cacheAge > tokenValidTimeInMilliSecond) {
                datapoint.addCustomProperty('Token expired', true);
            } else {
                datapoint.addCustomProperty('Token expired', false);
            }
        }

        if (fileViewState.thumbnailUrlTemplate && fileViewState.thumbnailUrlTemplate.length > 0) {
            // Add the height and width of the image to the URL.
            const imagePreviewUrl = fileViewState.thumbnailUrlTemplate
                .replace('{0}', imagePreviewSize.toString())
                .replace('{1}', imagePreviewSize.toString());
            if (imagePreviewUrl) {
                const setImagePreviewState = await lazySetImagePreviewState.import();
                setImagePreviewState(
                    getSxSViewStore().viewState,
                    imagePreviewUrl,
                    null, // ImageGallery
                    optionalParameters
                );
            } else {
                throw new Error('Image preview url is invalid.');
            }
        } else {
            throw new Error('Image thumbnail url template is invalid.');
        }
    } catch (error) {
        await handleSetViewStateFailure(error, loc(errorImageAttachment), datapoint);
    }
}
